var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemePark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.5935C15.3084 17.5935 17.9903 14.9116 17.9903 11.6032C17.9903 8.29484 15.3084 5.61287 12 5.61287C8.69164 5.61287 6.00967 8.29484 6.00967 11.6032C6.00967 14.9116 8.69164 17.5935 12 17.5935ZM12 18.5935C15.8607 18.5935 18.9903 15.4639 18.9903 11.6032C18.9903 7.74255 15.8607 4.61287 12 4.61287C8.13935 4.61287 5.00967 7.74255 5.00967 11.6032C5.00967 15.4639 8.13935 18.5935 12 18.5935Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.08384C13.3914 9.08384 14.5194 10.2118 14.5194 11.6032C14.5194 12.9946 13.3914 14.1226 12 14.1226C10.6086 14.1226 9.48065 12.9946 9.48065 11.6032C9.48065 10.2118 10.6086 9.08384 12 9.08384ZM12 8.08384C13.9437 8.08384 15.5194 9.65951 15.5194 11.6032C15.5194 13.5469 13.9437 15.1226 12 15.1226C10.0563 15.1226 8.48065 13.5469 8.48065 11.6032C8.48065 9.65951 10.0563 8.08384 12 8.08384Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9296 10.4804L16.9708 20.036L16.0863 20.5026L11.9421 12.6473L7.91638 20.4975L7.02657 20.0411L11.9296 10.4804Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6275 11.6032C3.6275 11.3271 3.85136 11.1032 4.1275 11.1032H19.8725C20.1486 11.1032 20.3725 11.3271 20.3725 11.6032C20.3725 11.8793 20.1486 12.1032 19.8725 12.1032H4.1275C3.85136 12.1032 3.6275 11.8793 3.6275 11.6032Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.9757C11.7239 19.9757 11.5 19.7518 11.5 19.4757L11.5 3.73071C11.5 3.45456 11.7239 3.23071 12 3.23071C12.2761 3.23071 12.5 3.45456 12.5 3.73071L12.5 19.4757C12.5 19.7518 12.2761 19.9757 12 19.9757Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07976 17.5235C5.8845 17.3282 5.8845 17.0116 6.07976 16.8163L17.2132 5.68295C17.4084 5.48769 17.725 5.48769 17.9203 5.68295C18.1155 5.87822 18.1155 6.1948 17.9203 6.39006L6.78687 17.5235C6.59161 17.7187 6.27503 17.7187 6.07976 17.5235Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9202 17.5235C17.725 17.7187 17.4084 17.7187 17.2131 17.5235L6.07973 6.39006C5.88447 6.1948 5.88447 5.87822 6.07973 5.68295C6.275 5.48769 6.59158 5.48769 6.78684 5.68295L17.9202 16.8163C18.1155 17.0116 18.1155 17.3282 17.9202 17.5235Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemePark);
export default __webpack_public_path__ + "static/media/theme_park.1501b68112e0ff2f3621e0277ce812b1.svg";
export { ForwardRef as ReactComponent };